import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.5 2V4M1.5 3H3.5M3 9V11M2 10H4M6.5 2L7.64286 5.42857L10.5 6.5L7.64286 7.57143L6.5 11L5.35714 7.57143L2.5 6.5L5.35714 5.42857L6.5 2Z" />
  </svg>
);
